export const loginErrorCodes = {
  WRONG_PASSWORD_ERROR: "WRONG_PASSWORD_ERROR",
  NO_PERMISSIONS_ERROR: "NO_PERMISSIONS_ERROR",
  SOCKET_HANDSHAKE_ERROR: "SOCKET_HANDSHAKE_ERROR",
};
